import { useEffect, type RefObject } from "react";

const FADE_AFTER_MS = 3_000;

/** On a phone, the controls step aside while the story plays. A tap brings them back. */
export function useFadingControls(playing: boolean, stageRef: RefObject<HTMLElement | null>): void {
  useEffect(() => {
    const stage = stageRef.current;
    if (stage === null || !playing || !window.matchMedia("(pointer: coarse)").matches) {
      return;
    }
    // On the page root, so the top bar outside the stage fades too.
    const root = document.documentElement;
    let timer: ReturnType<typeof setTimeout>;
    const show = (): void => {
      delete root.dataset.controlsFaded;
      clearTimeout(timer);
      timer = setTimeout(() => {
        root.dataset.controlsFaded = "true";
      }, FADE_AFTER_MS);
    };
    show();
    window.addEventListener("pointerdown", show, true);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("pointerdown", show, true);
      delete root.dataset.controlsFaded;
    };
  }, [playing, stageRef]);
}
